import React from "react"
import {useStaticQuery, graphql} from "gatsby"
import {getLangs} from "./common";

const Seo = ({seo = {}, pageContext}) => {
    const {strapiGlobal} = useStaticQuery(graphql`
    query {
      strapiGlobal {
        siteName
        favicon {
          localFile {
            url
          }
        }
        defaultSeo {
          metaTitle
          metaDescription
          shareImage {
            localFile {
              url
            }
          }
        }
      }
    }
  `)

    const {siteName, defaultSeo, favicon} = strapiGlobal

    // Merge default and page-specific SEO values
    const fullSeo = {...defaultSeo, ...seo}

    // Add site name to title
    fullSeo.metaTitle = fullSeo.metaTitle ? `${fullSeo.metaTitle} | ${siteName}` : siteName;

    const getMetaTags = () => {
        const tags = []

        if (fullSeo.metaTitle) {
            tags.push(
                {
                    property: "og:title",
                    content: fullSeo.metaTitle,
                },
                {
                    name: "twitter:title",
                    content: fullSeo.metaTitle,
                }
            )
        }
        if (fullSeo.metaDescription) {
            tags.push(
                {
                    name: "description",
                    content: fullSeo.metaDescription,
                },
                {
                    property: "og:description",
                    content: fullSeo.metaDescription,
                },
                {
                    name: "twitter:description",
                    content: fullSeo.metaDescription,
                }
            )
        }
        if (fullSeo.shareImage) {
            let imageUrl = fullSeo.shareImage.formats?.large?.url ?? fullSeo.shareImage.url;
            if (imageUrl) {
                imageUrl = `${process.env.STRAPI_API_URL}${imageUrl}`;
            } else if (fullSeo.shareImage.localFile?.url) {
                imageUrl = fullSeo.shareImage.localFile?.url;
            }
            tags.push(
                {
                    name: "image",
                    content: imageUrl,
                },
                {
                    property: "og:image",
                    content: imageUrl,
                },
                {
                    name: "twitter:image",
                    content: imageUrl,
                }
            )
        }
        if (fullSeo.article) {
            tags.push({
                property: "og:type",
                content: "article",
            })
        }
        tags.push({name: "twitter:card", content: "summary_large_image"})
        tags.push({name: "fb:app_id", content: "289296172429506"})

        return tags
    }

    const metaTags = getMetaTags()

    const seoMeta = [
        (<title key={'title'}>{fullSeo.metaTitle}</title>),
        (<link key={'apple-touch-icon'} rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png"/>),
        (<link key={'icon32'} rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png"/>),
        (<link key={'icon16'} rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png"/>),
        (<link key={'manifest'} rel="manifest" href="/site.webmanifest"/>),
        (<meta key={'theme-color'} name="theme-color" content="#ffffff"/>),
    ];

    const langs = getLangs(pageContext);
    if (pageContext?.canonical) {
        seoMeta.push(<link key={'canonical'} rel="canonical" href={pageContext.canonical}/>);
    }
    if (pageContext?.alternates) {
        for (const locale of Object.keys(pageContext.alternates)) {
            seoMeta.push(<link key={locale} rel="alternate" hrefLang={locale}
                               href={pageContext.alternates[locale].url}/>);
        }
    }
    // console.log('langs', pageContext?.canonical, pageContext?.alternates, langs);

    for (const [index, metaTag] of metaTags.entries()) {
        const props = {};
        for (const attr of Object.keys(metaTag)) {
            props[attr] = metaTag[attr];
            if (attr === 'name' || attr === 'property') {
                props.id = `${metaTag[attr]}-${index}`;
            }
        }
        seoMeta.push(<meta key={index} {...props} />);
    }

    return (
        <>
            {seoMeta}
        </>
    );
}

export default Seo;
